/* global JSX */
import * as React from "react";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { List } from "../../../List/List";
import { ITaskValidationRow } from "ui/Scripts/source/models/task/taskValidationRow";
import { TaskDataRowDataType } from "ui/Scripts/source/models/enums";
import { Box } from "@mui/material";
import { IListValueLineData } from "source/components/framework/List/ListLine";

export interface IReportExcelReportTableProp {
    height?: string;
    taskType: ITaskEditTypeItem;
    dataRows: ITaskDataRow[];
    totalTaskType?: ITaskEditTypeItem;
    totalRow?: ITaskDataRow;
    validationRows?: ITaskValidationRow[];
    sortingDisabled?: boolean;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    multiSelect?: boolean;
    selectedId?: string;
    selectedColumn?: string;
    checkedIds?: string[];
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
    onSetSelectedIds?: (selectedId: string, checkedIds: string[]) => void;
    onColumnClick?: (column: string) => void;
}

export interface IReportExcelReportTableState {
    sortColumn: string;
    sortOrderIsAsc: boolean;
    dataRows: ITaskDataRow[];
}

export class ReportExcelReportTable extends React.Component<IReportExcelReportTableProp, IReportExcelReportTableState> {
    getSortColumnFromProps = (props: IReportExcelReportTableProp): string => {
        let result = props.sortColumn ?? "";
        if (props.taskType && props.taskType.lineCols.length > 0) {
            if (!props.taskType.lineCols.find(i => i.field === result)) {
                result = props.taskType.lineCols[0].field;
            }
        }
        return result;
    };

    constructor(props: IReportExcelReportTableProp) {
        super(props);
        const sortColumn = this.getSortColumnFromProps(props);
        const sortOrderIsAsc = props.sortColumn ? props.sortOrderIsAsc : true;
        this.state = {
            sortColumn,
            sortOrderIsAsc,
            dataRows: props.dataRows ? props.dataRows : [],
        };
    }

    filteredList = (column: string, asc: boolean) => {
        const props = this.props;
        const dataRows = props.dataRows ? props.dataRows.slice(0) : [];
        TaskDataRow.sortTaskDataRowsByColumn(dataRows, props.taskType, column, asc);
        if (props.onSetSortData) {
            props.onSetSortData(column, asc);
        }
        this.setState({
            sortColumn: column,
            sortOrderIsAsc: asc,
            dataRows
        });
    };

    componentDidUpdate(prevProps: IReportExcelReportTableProp, prevState: IReportExcelReportTableState) {
        const props = this.props;
        const prevSortColumn = this.getSortColumnFromProps(prevProps);
        const sortColumn = this.getSortColumnFromProps(props);
        const prevSortOrderIsAsc = prevProps.sortColumn ? prevProps.sortOrderIsAsc : true;
        const sortOrderIsAsc = props.sortColumn ? props.sortOrderIsAsc : true;
        const prevDataRowsHash = prevProps.dataRows ? TaskDataRow.getHash(prevProps.dataRows) : "";
        const dataRowsHash = props.dataRows ? TaskDataRow.getHash(props.dataRows) : "";
        if (prevDataRowsHash === dataRowsHash && prevSortColumn === sortColumn && prevSortOrderIsAsc === sortOrderIsAsc) return;
        this.filteredList(sortColumn, sortOrderIsAsc);
    };
    
    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        this.filteredList(sortColumn, sortOrderIsAsc);
    };

    getLine = (dataRow: ITaskDataRow, taskType: ITaskEditTypeItem): IListValueLineData => {
        const props = this.props;
        const validationRow = props.validationRows && props.validationRows.length
            ? props.validationRows.find(i => i.id === dataRow.id)
            : null;
        return {
            columns: taskType.lineCols.map((dataCol) => {
                const validationCol = validationRow
                    ? validationRow.cols.find(j => j.field === dataCol.field)
                    : null;
                const uiValue = dataRow.getTaskDataRowColListUiValue(dataCol.field, taskType);
                const text = uiValue.text;
                let value: JSX.Element = null;
                if (dataCol.dataType === TaskDataRowDataType.Signature && text) {
                    value = <Box
                        component="img"
                        sx={{
                            width: "100%",
                            objectFit: "contain"
                        }}
                        src={`data:image/png;base64,${text}`}
                    />;
                }
                return {
                    styleClass: dataCol.class,
                    column: dataCol.field,
                    errors: validationCol
                        ? validationCol.errors
                        : [],
                    content: value ?? text
                };
            }),
            id: dataRow.id
        };
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <List
                height={props.height}
                intialized={true}
                isLoading={false}
                hasMore={false}
                globalLoadingInUse={false}
                multiSelect={props.multiSelect}
                header={{
                    columns: props.taskType.lineCols.map(i => {
                        return { styleClass: "colTitleContainer " + i.class + (!!props.selectedColumn && props.selectedColumn === i.field ? " col-selected" : ""), column: i.field, content: i.title };
                    })
                }}
                lines={state.dataRows.map((dataRow) => this.getLine(dataRow, props.taskType))}
                totalLine={props.totalRow && props.totalTaskType ? this.getLine(props.totalRow, props.totalTaskType) : null}
                sortColumn={props.sortingDisabled ? "" : state.sortColumn}
                sortOrderIsAsc={state.sortOrderIsAsc}
                selectedId={props.multiSelect ? props.selectedId : ""}
                checkedIds={props.multiSelect ? props.checkedIds : []}
                selectedColumn={props.selectedColumn}
                onSetSelectedIds={props.multiSelect ? props.onSetSelectedIds : null}
                onSearchLines={this.handleSearchLines}
                onColumnClick={props.onColumnClick}
            />
        );
    }
}